import { Injectable } from '@angular/core';
import { merge, Observable } from 'rxjs';
import { distinctUntilChanged, map, tap } from 'rxjs/operators';

import { MatFormField } from '@angular/material/form-field';
import { LcsSingleSelectInputService } from '../single-select-input.service';
import { LcsSingleSelectDirective } from '../single-select.directive';

@Injectable({ providedIn: 'root' })
export class LcsStaticSingleSelectStatusService {
   constructor(private singleSelectInputService: LcsSingleSelectInputService) {}

   initialize(
      formField: MatFormField,
      trigger: LcsSingleSelectDirective<any>,
      element: HTMLInputElement,
      search: (searchTerm: string | null | undefined) => void,
      searchReset: () => void,
      filteredItemCount: Observable<number>
   ) {
      const { blur, closed, input } = this.singleSelectInputService.getObservables(
         trigger,
         element,
         search,
         searchReset
      );

      const noResult = filteredItemCount.pipe(
         map((itemCount: number) => {
            return itemCount === 0;
         }),
         distinctUntilChanged(),
         tap((isEmpty: boolean) => {
            if (formField._control.value == null) {
               formField.hintLabel = isEmpty ? 'No results found.' : '';
               trigger.stateChanges.next();
            }
         })
      ) as Observable<never>;

      return merge(blur, closed, input, noResult);
   }
}
